var parse=require('../parse/index.js');var startOfYear=require('../start_of_year/index.js');var differenceInCalendarDays=require('../difference_in_calendar_days/index.js');/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */function getDayOfYear(dirtyDate){var date=parse(dirtyDate);var diff=differenceInCalendarDays(date,startOfYear(date));var dayOfYear=diff+1;return dayOfYear;}module.exports=getDayOfYear;